import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useExportData } from "@planzone/view-models";
import { ExportsDataTypes, ExportsFormats } from "@planzone/dto";

import { Checkbox } from "@common/checkbox";
import { Button } from "@common/button";
import { DateTimeInput } from "@common/dateTimeInput";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceAllocatedTimeReport(props: Props) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { isRequestPending, exportData } = useExportData();

  return (
    <div
      className={classNames(styles.report, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("exportReportsPage.resourceAllocatedTimeReport.title")}
          </h2>
          <p className={styles.description}>
            {t("exportReportsPage.resourceAllocatedTimeReport.subTitle")}
          </p>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={!startDate || !endDate}
            press={() =>
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.RESOURCE_ALLOCATED_TIME_REPORT,
                  data: {
                    planzone: props.planzone,
                    startDate: startDate,
                    endDate: endDate,
                  },
                },
                format: ExportsFormats.EXCEL,
              })
            }
          >
            {t("exportReportsPage.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("exportReportsPage.resourceAllocatedTimeReport.startDate")}
            </h3>
            <DateTimeInput
              dateTime={startDate}
              placeholder={t(
                "exportReportsPage.resourceAllocatedTimeReport.startDate",
              )}
              input={setStartDate}
            />
          </div>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("exportReportsPage.resourceAllocatedTimeReport.endDate")}
            </h3>
            <DateTimeInput
              dateTime={endDate}
              placeholder={t(
                "exportReportsPage.resourceAllocatedTimeReport.endDate",
              )}
              input={setEndDate}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export { ResourceAllocatedTimeReport };
